import React from 'react';
import { isEmptyObject } from 'common/utilities/utils';
import { getImageComponent } from 'common/sharedTemplates/sharedTemplates';

const DownloadKfcContainer = ({ downloadData }) => {

  return (
    <>
      {isEmptyObject(downloadData) && (
        <div className='downloadapp-component-container' data-testid='downloadapp-component-container'>
          <div className='grid-container'>
            <div class='stri-ICON'>
              {getImageComponent(downloadData?.stripeIcon, 'APP_DETAIL_SECTION_STRIPES')}
            </div>
            <div className='downloadapp-image-container'>
              <div className='app-detail-section'>
                <div className='col-xl-7 col-lg-6 col-md-12 col-12 set-wid ml-set app-store-details'>
                  <div className='title'>{downloadData?.headLine}</div>
                  <div className='store-img'>
                    <a target='_blank' href={downloadData?.appleStoreUrl} rel='noreferrer'>
                      {getImageComponent(downloadData?.appleStoreIcon, 'APPLE_GOOGLE_STORE')}
                    </a>
                    <a target='_blank' href={downloadData?.googlePlayUrl} rel='noreferrer'>
                      {getImageComponent(downloadData?.googlePlayIcon, 'APPLE_GOOGLE_STORE')}
                    </a>
                  </div>
                </div>
                <div className='col-xl-5 col-lg-6 col-md-12 col-12 set-wid image-icon'>
                  {getImageComponent(downloadData?.imageIcon, 'APP_DETAIL_SECTION_IMAGE')}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default DownloadKfcContainer;
